import * as React from 'react';
import {Datagrid, List, ListProps, EditButton, ReferenceField} from 'react-admin';
import {Fragment, ReactElement} from 'react';
import { Route } from 'react-router';

import TypeFilter from "./TypeFilter";
import TypeEdit from "./TypeEdit";
import SideDrawer from "../../../components/list/SideDrawer";
import TextField from "../../../components/list/TextField";
import ListActions from "../../../components/list/ListActions";

const TypeList = (props: ListProps): ReactElement => {

    return (
        <Fragment>
            <List {...props} filters={<TypeFilter/>} sort={{field: 'id', order: 'DESC'}} actions={<ListActions/>}>
                <Datagrid>
                    <TextField source="id" />
                    <ReferenceField reference={'admin/cob-manufacturers'} source={'cob_manufacturer_id'} label={'resources.admin/cob-types.fields.manufacturer'}>
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField source="name" />
                    <EditButton/>
                </Datagrid>
            </List>

            <Route path={`${props.basePath}/:id`}>
                {({ match }) => {
                    const isMatch = !!(match && match.params && match.params.id !== 'create');
                    return (
                        <SideDrawer open={isMatch} basePath={props.basePath??''}>
                            {isMatch && (
                                <TypeEdit id={match && isMatch ? match.params.id : undefined}{...props}/>
                            )}
                        </SideDrawer>
                    );
                }}
            </Route>
        </Fragment>
    );
};

export default TypeList;
